export const SCHEMA_DASHBOARD_TAB_KEY = "schema-dashboard-active-tab";

export const SCHEMA_DASHBOARD_FILTERS_LOCALSTORAGE_KEY =
  "schema-dashboard-filters";

// The dashboard's page filters live in per-definition React state, while Duck
// rebuilds its app_state from the URL + localStorage at prompt time
// (duck/ui/utils.ts). The active view mirrors its merged filters under the key
// above (useDuckFiltersMirror) to make them visible to Duck.
export interface SchemaDashboardDuckFilters {
  schemaName: string;
  versionKey: string;
  eventFilter: string | null;
  assetFilter: string | null;
}

export const MY_PROJECTS_TAB_KEY = "my-projects";
